import { CommonModule } from '@angular/common';
import { Component, inject, Inject } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialog as MatDialog,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { RuleSetsImportModalComponent } from '@app/modules/calendar/components/rule-sets-import-modal/rule-sets-import-modal.component';
import { UiModule } from '@app/ui';
import { ApiSimplePropertyRuleset } from '@app/features/property-rulesets/property-ruleset.interface';
import { PropertyRulesetService } from '@app/features/property-rulesets/property-ruleset.service';
import { firstValueFrom } from 'rxjs';
import { SegmentEvent, SegmentIoService } from '@app/shared/services/segmentIo/segment-io.service';

type RuleSetsImportDialogData = {
  rulesets: ApiSimplePropertyRuleset[];
};

@Component({
  standalone: true,
  selector: 'sbnb-rule-sets-opt-in-modal',
  templateUrl: './rule-sets-opt-in-modal.component.html',
  styleUrls: ['./rule-sets-opt-in-modal.component.scss'],
  imports: [CommonModule, UiModule],
  providers: [],
})
export class RuleSetsOptInModalComponent {
  private propertyRulesetService = inject(PropertyRulesetService);
  constructor(
    public dialogRef: MatDialogRef<RuleSetsOptInModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public dialogData: RuleSetsImportDialogData,
    private dialog: MatDialog,
    private segmentIoService: SegmentIoService
  ) { }


  public reviewRuleSets() {
    const dialogRef = this.dialog.open(RuleSetsImportModalComponent, {
      disableClose: true,
      height: '100vh',
      width: '100vw',
      maxWidth: '100%',
      maxHeight: '100%',
      data: {
        rulesets: this.dialogData.rulesets,
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.propertyRulesetService.enableRulesetLayer()
      }
      this.closeModal();
    });
  }


  public async closeModal(optOut: boolean = false) {
    if (optOut) {
      this.segmentIoService.track(SegmentEvent.RuleSetsOptInModalNotNow, {});
      await firstValueFrom(this.propertyRulesetService.dismissOptIn());
    }
    this.dialogRef.close();
  }

} 